import { useEffect, useState } from 'react';

import { FormatProperties } from 'models/response/blockOutput.interface';

import IndicatorEditableField from './IndicatorEditableField';

interface Properties {
  isGrowthValue: boolean;
  fieldValue: string;
  formatProperties: FormatProperties;
  onSubmit: (
    value: string,
    indicatorName: string,
    callback: (value: boolean) => void,
    index: number,
  ) => void;
  indicatorName: string;
  index: number;
  isPercentage: boolean;
  isDisable?: boolean;
}

const EditBox = ({
  isGrowthValue,
  fieldValue,
  onSubmit,
  formatProperties,
  indicatorName,
  index,
  isPercentage,
  isDisable,
}: Properties) => {
  const [indicatorValue, setIndicatorValue] = useState('');
  useEffect(() => {
    setIndicatorValue(
      isPercentage && !isGrowthValue
        ? (+fieldValue * 100).toString()
        : !fieldValue
        ? '0'
        : fieldValue.toString(),
    );
  }, [fieldValue]);

  return (
    <IndicatorEditableField
      isGrowthValue={isGrowthValue}
      fieldValue={indicatorValue}
      onSubmit={onSubmit}
      formatProperties={formatProperties}
      setFieldValue={setIndicatorValue}
      indicatorName={indicatorName}
      index={index}
      isDisable={isDisable}
    />
  );
};
export default EditBox;
